var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3504 1.75H2.74531C1.94727 1.75 1.25 2.32422 1.25 3.11289V17.7504C1.25 18.5434 1.94727 19.25 2.74531 19.25H17.3461C18.1484 19.25 18.75 18.5387 18.75 17.7504V3.11289C18.7547 2.32422 18.1484 1.75 17.3504 1.75ZM6.67461 16.3371H4.16758V8.54219H6.67461V16.3371ZM5.50781 7.35703H5.48984C4.6875 7.35703 4.16797 6.75977 4.16797 6.01211C4.16797 5.25078 4.70117 4.66758 5.52148 4.66758C6.3418 4.66758 6.84375 5.24648 6.86172 6.01211C6.86133 6.75977 6.3418 7.35703 5.50781 7.35703ZM15.8371 16.3371H13.3301V12.075C13.3301 11.0539 12.9652 10.3563 12.0582 10.3563C11.3652 10.3563 10.9551 10.825 10.7727 11.2816C10.7043 11.4457 10.6859 11.6691 10.6859 11.8973V16.3371H8.17891V8.54219H10.6859V9.62695C11.0508 9.10742 11.6207 8.35977 12.9469 8.35977C14.5926 8.35977 15.8375 9.44453 15.8375 11.7832L15.8371 16.3371Z",
    fill: "#3E7FDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9235f33572d3fc013379a8a85a6ac9ac.svg";
export { ForwardRef as ReactComponent };